import { useEffect, useState } from 'react';
import SelectTextArea from '../../Components/Common/SelectTextArea';
import { useForm } from 'react-hook-form';
import CommonFormBtn from '../../Components/Common/CommonFormBtn';
import {
  useAddLeadNonRegisterVisitorInfo,
  useAddLogInVisitorComments,
} from './apiEndpoints/PublicProductServiceEndpoints';
import InputField from '../../Components/Common/InputField';
import { Link } from 'react-router-dom';
import { ICreateLeadVisitorOnly } from './apiEndpoints/pubAndSerTypes';
import { removeUndefinedAndNull } from '../../Components/Common/removeUndefinedAndNull';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';

const WriteProductComment = ({
  id,
  handleCloseModal,
  isLoggedIn,
}: {
  id: number;
  handleCloseModal?: () => void;
  isLoggedIn?: boolean;
}) => {
  const { visitorUser, dispatch } = VisitorAuthContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICreateLeadVisitorOnly>();

  const [onlyLead, setOnlyLead] = useState<boolean>(true);
  const { mutate, isPending, isSuccess } = useAddLeadNonRegisterVisitorInfo();
  const { mutate: logIn, isSuccess: logIsSuc } = useAddLogInVisitorComments(id);

  const onSubmit = (data: ICreateLeadVisitorOnly) => {
    const value = removeUndefinedAndNull({ ...data, product_id: id });

    if (isLoggedIn) {
      logIn(data);
    } else {
      mutate(value);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      handleCloseModal?.();
      setOnlyLead(!onlyLead);
    }
  }, [isSuccess]);
  useEffect(() => {
    if (logIsSuc) {
      handleCloseModal?.();
    }
  }, [logIsSuc]);
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {onlyLead ? (
          <>
            {!isLoggedIn && (
              <InputField
                label='Give your Registered Email'
                register={register('visitor_email')}
                isRequired
                type={'email'}
              />
            )}

            <SelectTextArea
              register={register('comment')}
              label='Write your Valuable Comment'
              rows={3}
            />
          </>
        ) : (
          <>
            <div className='row'>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-2'>
                <InputField
                  label='Name'
                  register={register('name')}
                  placeholder='Enter Name'
                  isRequired
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-2'>
                <InputField
                  label='Email'
                  register={register('email')}
                  placeholder='Enter Email'
                  isRequired
                />
              </div>
              <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3'>
                <InputField
                  label='Phone'
                  register={register('phone')}
                  placeholder='Enter Phone'
                  isRequired
                />
              </div>
              <div className='col-12'>
                <SelectTextArea
                  register={register('comment')}
                  label='Write your Valuable Comment'
                  rows={3}
                />
              </div>
            </div>
          </>
        )}

        <CommonFormBtn loading={isPending || logIsSuc} />

        {!Object?.keys(visitorUser)?.length && (
          <div className='d-flex align-items-center my-'>
            <div className='flex-grow-1 border-top border-secondary'></div>
            <span className='mx-2 py-2  text-black'>
              <Link to='/visitor-registration' className='text-decoration-none'>
                Visitor Registration or
              </Link>
            </span>{' '}
            <span
              className='me-1 pointer'
              onClick={() => setOnlyLead(!onlyLead)}
            >
              {onlyLead ? 'Lead Information Submission' : 'Back to previous'}
            </span>
            <div className='flex-grow-1 border-top border-secondary'></div>
          </div>
        )}
      </form>
    </>
  );
};

export default WriteProductComment;
